/*
 * gd-cart-fast.js — Etapa 5 de performance (Elos Link, set/2026)
 *
 * PROBLEMA MEDIDO (campo, 30 dias ago/2026): INP de 508ms no #product-add-to-cart,
 * 360ms na PDP e 368ms na home. 91% do tráfego é mobile e 63% vem do in-app browser
 * do Instagram, onde o INP chega a 504ms (contra 160ms no Safari) — essas webviews têm
 * menos folga de main thread, então trabalho síncrono no clique custa o dobro ali.
 *
 * CAUSA: halo.updateSidebarCart (assets/theme.js:4628) troca o HTML da gaveta e, no
 * MESMO tick, ainda roda no `complete` do $.ajax: inicialização de slider (slick) da
 * vitrine do carrinho, gift wrapper, conversão de moeda e o evento cart-update. Tudo
 * isso segura a main thread ANTES do primeiro paint da gaveta — e INP mede exatamente
 * interação → próximo paint.
 *
 * O QUE ESTE ARQUIVO FAZ: substitui halo.updateSidebarCart por uma versão que pinta a
 * gaveta primeiro e só depois faz o trabalho pesado, um frame adiante.
 *
 * O QUE ELE NÃO MUDA (de propósito):
 *   - a troca do HTML continua sendo `$(...).html(...)` do jQuery, e NÃO innerHTML:
 *     o markup da gaveta (snippets/halo-side-cart.liquid) tem <script> inline
 *     (window.cart_selling_array_* e o quantity-popover.js). innerHTML NÃO executa
 *     script inline — trocar por ele quebraria os planos de assinatura em silêncio.
 *   - a URL continua /cart?view=ajax_side_cart (template com {% layout none %}).
 *   - nenhuma regra de negócio: guards de kit/mini pote/garrafa, cupom, frete e
 *     rastreamento seguem intactos e no mesmo lugar.
 *
 * FALHA EM SILÊNCIO: se o halo ou o jQuery não aparecerem, ou se qualquer passo do
 * pós-paint lançar, a gaveta já está pintada e o original continua disponível.
 * ROLLBACK: remover a tag deste arquivo do layout — o theme.js volta a valer sozinho.
 */
(function () {
  "use strict";

  if (window.__gdCartFastBound) {
    return;
  }
  window.__gdCartFastBound = true;

  var SPINNER =
    '<div class="loading-overlay loading-overlay--custom">' +
    '<div class="loading-overlay__spinner">' +
    '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
    '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
    "</svg></div></div>";

  /* Esqueleto do carregamento. Na PRIMEIRA adição a gaveta está vazia, então o
     spinner do tema aparece sobre um fundo branco enquanto o HTML não volta do
     servidor — é o "carrinho branco por alguns segundos" relatado pelo cliente.
     Com duas linhas cinza no lugar, a gaveta já nasce com forma e a troca pelo
     conteúdo real não desloca nada. Some sozinho quando o HTML entra.
     Só é inserido quando a gaveta está vazia: em adições seguintes o conteúdo
     anterior continua na tela, que já é melhor que um esqueleto. */
  var SKELETON =
    '<div class="gd-cart-skeleton" aria-hidden="true">' +
    '<div class="gd-cart-skeleton__row"></div>' +
    '<div class="gd-cart-skeleton__row"></div>' +
    "</div>";

  var LOADING_CLASS = "is-loading";
  var WRAPPER_SEL = "#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper";

  /* Um frame + uma macrotask: garante que o paint da gaveta aconteceu antes de
     começarmos o trabalho caro. É o que tira esse trabalho da janela do INP. */
  function afterPaint(fn) {
    if (typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(function () {
        setTimeout(fn, 0);
      });
    } else {
      setTimeout(fn, 16);
    }
  }

  function safe(fn) {
    try {
      fn();
    } catch (e) {
      /* silêncio: nada aqui pode derrubar o carrinho */
    }
  }

  function install(halo, $) {
    var original = halo.updateSidebarCart;

    halo.updateSidebarCart = function (cart) {
      if (!cart || $.isEmptyObject(cart)) {
        return;
      }

      var $wrapper = $(WRAPPER_SEL);
      var $body = $("body");

      /* Sem o container esperado, devolve para o original em vez de inventar. */
      if (!$wrapper.length) {
        return original.call(halo, cart);
      }

      $wrapper.addClass(LOADING_CLASS).prepend(SPINNER);

      safe(function () {
        var el = $wrapper[0];
        if (el && !el.querySelector(".previewCartItem, [data-item-row]")) {
          $wrapper.append(SKELETON);
        }
      });

      /* Contadores do header: baratos e são o feedback que a pessoa olha primeiro.
         Atualizados JÁ, sem esperar a gaveta voltar do servidor. */
      safe(function () {
        $body.find("[data-cart-count]").text(cart.item_count);
        if (cart.item_count >= 100 && window.cartStrings) {
          $body
            .find(".cart-count-bubble [data-cart-count]")
            .text(window.cartStrings.item_99);
        }
        if (window.cartStrings) {
          $body
            .find("[data-cart-text]")
            .text(cart.item_count == 1 ? window.cartStrings.item : window.cartStrings.items);
        }
      });

      function finalize() {
        /* Ordem preservada em relação ao theme.js; só mudou o momento. */
        safe(function () {
          var progressBar = document.querySelector("cart-progressbar");
          if (progressBar && typeof progressBar.updateProgressBar === "function") {
            progressBar.updateProgressBar(cart);
          }
        });
        safe(function () {
          halo.dispatchChangeForShippingMessage();
        });
        safe(function () {
          halo.productCollectionCartSlider();
        });
        safe(function () {
          halo.updateGiftWrapper();
        });
        safe(function () {
          if (halo.checkNeedToConvertCurrency() && window.Currency) {
            window.Currency.convertAll(
              window.shop_currency,
              $("#currencies .active").attr("data-currency"),
              "span.money",
              "money_format"
            );
          }
        });
        safe(function () {
          document.dispatchEvent(new CustomEvent("cart-update", { detail: cart }));
        });
        safe(function () {
        });
      }

      $.ajax({
        type: "GET",
        /* window.routes.root é STRING VAZIA nesta loja (domínio sem subpasta de idioma).
           Um fallback com `||` ou ternário de truthiness a troca por "/" e monta
           "//cart?view=ajax_side_cart" — URL protocolo-relativa, que aponta para o host
           "cart" e devolve nada: a gaveta abre vazia. Testado no preview, 01/Set.
           Por isso a checagem é por null/undefined, e não por truthiness. */
        url: (window.routes && window.routes.root != null ? window.routes.root : "") + "/cart?view=ajax_side_cart",
        cache: false,
        success: function (data) {
          /* .html() e não innerHTML: precisa executar os <script> inline da gaveta. */
          $wrapper.removeClass(LOADING_CLASS).html($(data));
          /* A partir daqui a gaveta já pode pintar. O resto vai depois. */
          afterPaint(finalize);
        },
        error: function (xhr) {
          $wrapper.removeClass(LOADING_CLASS);
          safe(function () {
            halo.showWarning(xhr.statusText);
          });
          afterPaint(finalize);
        },
      });
    };
  }

  /* O esqueleto precisa aparecer quando a GAVETA ABRE, não quando o redesenho começa.
     Medido no preview (01/Set): o clique abre a gaveta na hora, mas o redesenho só é
     chamado depois que o /cart/add.js volta — e é nesse intervalo que a pessoa vê o
     branco. Observando a classe cart-sidebar-show no <body> o esqueleto entra no
     mesmo instante da abertura, cobrindo o buraco inteiro.
     Só age quando não há item na gaveta (primeira adição); com conteúdo anterior em
     tela, não mexe em nada. */
  function observarAbertura() {
    if (typeof MutationObserver !== "function" || !document.body) {
      return;
    }
    var obs = new MutationObserver(function () {
      var w = document.querySelector(WRAPPER_SEL);
      if (!w) {
        return;
      }
      /* Gaveta fechada: limpa qualquer resto de estado de carregamento, para que a
         próxima abertura nunca comece suja (rodapé empurrado / esqueleto fantasma). */
      if (!document.body.classList.contains("cart-sidebar-show")) {
        w.classList.remove(LOADING_CLASS);
        var restos = w.querySelectorAll(".gd-cart-skeleton");
        for (var i = 0; i < restos.length; i++) {
          if (restos[i].parentNode) {
            restos[i].parentNode.removeChild(restos[i]);
          }
        }
        return;
      }
      /* Seletores do markup REAL desta gaveta (previewCartItem / [data-item-row]).
         Os anteriores não existiam no tema: o teste dava "vazio" mesmo com itens e o
         esqueleto entrava sempre, empurrando o rodapé com o botão para fora da área
         visível (overflow: hidden). */
      if (w.querySelector(".previewCartItem, [data-item-row]")) {
        return;
      }
      if (w.querySelector(".gd-cart-skeleton")) {
        return;
      }
      w.classList.add(LOADING_CLASS);
      /* Antes do rodapé (.previewCartInfo), não no fim do wrapper: mesmo que o
         esqueleto entre, o botão de finalizar nunca fica abaixo dele. */
      var rodape = w.querySelector(".previewCartInfo");
      if (rodape) {
        rodape.insertAdjacentHTML("beforebegin", SKELETON);
      } else {
        w.insertAdjacentHTML("beforeend", SKELETON);
      }
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observarAbertura);
  } else {
    observarAbertura();
  }

  var tentativas = 0;
  function boot() {
    var halo = window.halo;
    var $ = window.jQuery;
    if (halo && $ && typeof halo.updateSidebarCart === "function") {
      install(halo, $);
      return;
    }
    /* ~10s de espera e desiste: o theme.js é deferido e o halo só existe depois dele. */
    if (++tentativas > 100) {
      return;
    }
    setTimeout(boot, 100);
  }

  boot();
})();
